import React from "react";
import { Helmet } from "react-helmet";

const SEO = ({ title, description, socialImage }) => {
  const site = {
    siteMetadata: {
      siteTitle: "Twika🔥🔥",
      siteDesc: "Twika | Gain more with making hommies 🔥🔥🔥",
      image: "",
      siteUrl: process.env.REACT_APP_BASE_FRONTEND_URL,
      author: "",
      twitterUsername: "",
    },
  };

  const {
    siteDesc,
    siteTitle,
    siteUrl,
    image,
    twitterUsername,
  } = site.siteMetadata;

  return (
    <Helmet
      htmlAttributes={{ lang: "en" }}
      title={title ? `${title} | ${siteTitle}` : siteTitle}
    >
      <meta name="description" content={description || siteDesc} />
      <meta name="image" content={`${siteUrl}${socialImage || image}`} />
      {/* facebook cards */}
      <meta property="og:url" content={siteUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={siteDesc} />
      <meta property="og:image" content={`${siteUrl}${socialImage || image}`} />
      <meta property="og:image:width" content="400" />
      <meta property="og:image:height" content="300" />
      {/* twitter card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:creator" content={twitterUsername} />
      <meta name="twitter:title" content={siteTitle} />
      <meta name="twitter:description" content={siteDesc} />
      <meta
        name="twitter:image"
        content={`${siteUrl}${socialImage || image}`}
      />
    </Helmet>
  );
};

export default SEO;
